<template>
  <AppBottomSheet
    v-if="call"
    :open="open"
    :title="call.label"
    @update:open="CallSheetService.close()"
  >
    <div
      v-if="call.intro && call.illustration"
      class="call-sheet__art tw:relative tw:overflow-hidden tw:mb-3 tw:rounded-(--radius-card-navigation) tw:bg-(--surface-input)"
    >
      <img class="tw:w-full" :src="'/images/nkf/' + call.illustration + '.webp'" alt="" />
      <p
        class="call-sheet__bubble tw:absolute tw:text-(--muted-foreground) tw:type-caption tw:pt-4.5 tw:pr-3.5 tw:pb-0 tw:pl-4.5"
      >
        {{ call.intro }}
      </p>
    </div>
    <p v-else-if="call.intro" class="call-sheet__intro text-muted tw:type-caption tw:mb-3">
      {{ call.intro }}
    </p>
    <div
      class="call-sheet tw:grid tw:justify-items-center tw:text-center tw:gap-1.5 tw:pt-1 tw:px-0 tw:pb-1.5"
    >
      <span
        class="icon-well call-sheet__icon tw:text-(--result-normal) tw:bg-(--success-soft) tw:w-14.5 tw:h-14.5 tw:mb-1.5"
        ><AppIcon size="dialog" name="phone"
      /></span>
      <strong class="call-sheet__number tw:type-hero">{{ call.number }}</strong>
      <p class="text-muted tw:type-body-small">{{ t('nkf.callSheet.hint') }}</p>
    </div>
    <template #secondary-actions>
      <Button variant="outline" @click="CallSheetService.close()">{{ t('nkf.cancel') }}</Button>
    </template>
    <template #footer>
      <Button as-child variant="success"
        ><a :href="'tel:' + call.number.replace(/[^+\d]/g, '')"
          ><AppIcon size="action" name="phone" />{{ t('nkf.callSheet.callNow') }}</a
        ></Button
      >
    </template>
  </AppBottomSheet>
</template>

<script setup>
// 1. Import necessary components
import { useI18n } from 'vue-i18n';
import AppIcon from './AppIcon.vue';
import AppBottomSheet from './AppBottomSheet.vue';
import { Button } from './ui/button';
import { CallSheetService } from '@/shared/utilities/feedback/call-sheet-service';
// 2. Use
const { t } = useI18n();
const call = CallSheetService.active;
const open = CallSheetService.isOpen;
// 3. Define a reactive variable
// 4. Define methods or computed properties if needed
// 5. VueJS Hooks
</script>

<style scoped>
.call-sheet__bubble {
  left: 44%;
  top: 6%;
  width: 53%;
}
</style>
